// src/pages/ChangePassword.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export default function ChangePassword() {
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showCon, setShowCon] = useState(false);

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");

  const token = useMemo(() => {
    return localStorage.getItem("token") || localStorage.getItem("authToken") || "";
  }, []);

  useEffect(() => {
    if (!token) navigate("/login", { replace: true });
  }, [token, navigate]);

  const clearMsgs = () => {
    setErr("");
    setOk("");
  };

  const resetForm = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    clearMsgs();
  };

  const submit = async (e) => {
    e.preventDefault();
    clearMsgs();

    const oldP = String(oldPassword || "").trim();
    const newP = String(newPassword || "").trim();
    const conP = String(confirmPassword || "").trim();

    if (!oldP) return setErr("Please enter old password.");
    if (!newP) return setErr("Please enter new password.");
    if (newP.length < 6) return setErr("New password must be at least 6 characters.");
    if (newP !== conP) return setErr("Confirm password does not match.");
    if (oldP === newP) return setErr("New password must be different from old password.");

    try {
      setLoading(true);
      const res = await axiosInstance.post(
        "/api/users/change-password",
        { oldPassword: oldP, newPassword: newP },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setOk(res?.data?.msg || res?.data?.message || "Password changed successfully ✅");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (e2) {
      setErr(
        e2?.response?.data?.msg ||
          e2?.response?.data?.message ||
          e2?.message ||
          "Change password failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{css}</style>

      <div className="cpPage">
        <div className="cpWrap">
         {/*} <div className="cpHead">
            <div>
              <div className="cpTitle">Change Password</div>
              <div className="cpSub">Update your password securely</div>
            </div>

            <div className="cpHeadBtns">
              <button className="cpBtn" type="button" onClick={() => navigate(-1)} disabled={loading}>
                ← Back
              </button>
              <button className="cpBtn ghost" type="button" onClick={resetForm} disabled={loading}>
                Clear
              </button>
            </div>
          </div>*/}

          {err ? <div className="cpAlert err">{err}</div> : null}
          {ok ? <div className="cpAlert ok">{ok}</div> : null}

          <form className="cpCard" onSubmit={submit}>
            <div className="cpField">
              <div className="cpLabel">Old Password</div>
              <div className="cpRow">
                <input
                  className="cpInput"
                  type={showOld ? "text" : "password"}
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  placeholder="Enter old password"
                  autoComplete="current-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="cpEye"
                  onClick={() => setShowOld((v) => !v)}
                  disabled={loading}
                >
                  {showOld ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="cpField">
              <div className="cpLabel">New Password</div>
              <div className="cpRow">
                <input
                  className="cpInput"
                  type={showNew ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  autoComplete="new-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="cpEye"
                  onClick={() => setShowNew((v) => !v)}
                  disabled={loading}
                >
                  {showNew ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="cpField">
              <div className="cpLabel">Confirm Password</div>
              <div className="cpRow">
                <input
                  className="cpInput"
                  type={showCon ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Re-enter new password"
                  autoComplete="new-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="cpEye"
                  onClick={() => setShowCon((v) => !v)}
                  disabled={loading}
                >
                  {showCon ? "Hide" : "Show"}
                </button>
              </div>

              {confirmPassword.length > 0 && (
                <div className={"cpMatch " + (newPassword === confirmPassword ? "ok" : "err")}>
                  {newPassword === confirmPassword ? "✅ Passwords match" : "❌ Passwords do not match"}
                </div>
              )}
            </div>

            <div className="cpActions">
              
              <button className="cpBtn primary" type="submit" disabled={loading}>
                {loading ? "Saving..." : "Save Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

const css = `
  *{ box-sizing:border-box; margin:0; padding:0; }
  html,body,#root{ height:100%; }
  body{
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto;
    background:#ffffff;
    color:#0f172a;
  }

  .cpPage{ min-height:100vh; padding: 18px 0 60px; }
  .cpWrap{ width:min(720px, 100%); margin:0 auto; padding: 0 16px; }

  .cpHead{
    border: 1px solid rgba(15,23,42,.10);
    border-radius: 18px;
    padding: 16px;
    background:#fff;
    box-shadow: 0 12px 28px rgba(0,0,0,.08);
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .cpTitle{ font-size: 26px; font-weight: 950; }
  .cpSub{ margin-top: 6px; font-size: 13px; color: rgba(15,23,42,.65); font-weight: 800; }
  .cpHeadBtns{ display:flex; gap: 10px; flex-wrap: wrap; }

  .cpBtn{
    height: 42px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid rgba(15,23,42,.12);
    background: rgba(15,23,42,.04);
    color:#0f172a;
    font-weight: 900;
    cursor:pointer;
  }
  .cpBtn:disabled{ opacity:.6; cursor:not-allowed; }
  .cpBtn.ghost{ background:#fff; }
  .cpBtn.primary{
    border-color: rgba(37,99,235,.25);
    background: rgba(37,99,235,.10);
    color:#1d4ed8;
  }

  .cpAlert{
    margin-top: 12px;
    padding: 12px 14px;
    border-radius: 16px;
    border: 1px solid rgba(15,23,42,.10);
    background:#fff;
    box-shadow: 0 10px 22px rgba(0,0,0,.06);
    font-weight: 900;
  }
  .cpAlert.err{
    border-color: rgba(239,68,68,.25);
    background: rgba(239,68,68,.06);
    color:#7f1d1d;
  }
  .cpAlert.ok{
    border-color: rgba(34,197,94,.25);
    background: rgba(34,197,94,.10);
    color:#065f46;
  }

  .cpCard{
    margin-top: 12px;
    border: 1px solid rgba(15,23,42,.10);
    border-radius: 18px;
    background:#fff;
    box-shadow: 0 12px 28px rgba(0,0,0,.08);
    padding: 16px;
  }

  .cpField{ display:grid; gap: 8px; margin-bottom: 14px; }
  .cpLabel{ font-size: 12px; font-weight: 950; color: rgba(15,23,42,.70); }

  /* ✅ Always side-by-side (even mobile) */
  .cpRow{
    display:grid;
    grid-template-columns: 1fr 82px;
    gap: 10px;
    align-items:center;
  }

  .cpInput{
    height: 46px;
    border-radius: 14px;
    border: 1px solid rgba(15,23,42,.12);
    background:#fff;
    color:#0f172a;
    padding: 0 12px;
    outline:none;
  }
  .cpInput:focus{
    border-color: rgba(37,99,235,.35);
    box-shadow: 0 0 0 4px rgba(37,99,235,.12);
  }

  /* ✅ small box show button */
  .cpEye{
    height: 46px;
    width: 82px;
    border-radius: 14px;
    border: 1px solid rgba(15,23,42,.12);
    background: rgba(15,23,42,.04);
    color:#0f172a;
    font-weight: 900;
    cursor:pointer;
  }

  .cpMatch{
    margin-top: 6px;
    font-size: 12px;
    font-weight: 950;
  }
  .cpMatch.ok{ color:#065f46; }
  .cpMatch.err{ color:#7f1d1d; }

  .cpActions{
    display:flex;
    justify-content:space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 6px;
  }

  @media (max-width: 420px){
    .cpWrap{ padding: 0 12px; }
    .cpBtn{ width: 100%; }
    .cpHeadBtns{ width: 100%; }
    .cpActions .cpBtn{ width: 100%; }
  }
`;